<template>
  <div
    v-touch-pan.right.prevent.mouse="handlePan"
    class="silder-range border-radius-8 font-size-16"
    :class="rangeStatus ? 'success' : ''"
  >
    <div id="ssss" />
    <q-icon loading name="font:dm-shide-right" class="silder-box" size="20px" />
    {{ rangeStatus ? successText : startText }}
  </div>
</template>
<script>
export default {
  name: 'SilderVerify',
  props: {
    // 成功文字
    successText: {
      type: String,
      default: '',
    },
    // 开始的文字
    startText: {
      type: String,
      // default: this.$t('result.pickupCompletedBtn'),
      default: '',
    },
  },
  data() {
    return {
      rangeStatus: '',
      disX: 0,
    };
  },
  methods: {
    handlePan({ evt, ...info }) {
      const ele = evt.target;
      const eleWidth = ele.offsetWidth;
      const parentWidth = ele.parentElement.offsetWidth;
      const aaa = document.getElementById('ssss');
      const MaxX = parentWidth - eleWidth;
      if (this.rangeStatus) return false;
      this.disX = info.distance.x;
      if (this.disX >= MaxX - eleWidth) {
        this.disX = MaxX;
      }
      ele.style.transition = '0s all';
      aaa.style.transition = 'unset';
      ele.style.transform = `translateX(${this.disX - 8}px)`;
      aaa.style.width = `${this.disX - 3}px`;
      evt.preventDefault();
      if (info.isFinal) {
        if (this.disX !== MaxX) {
          ele.style.transition = '.2s all';
          ele.style.transform = 'translateX(0)';
          aaa.style.transition = '.2s all';
          aaa.style.width = '0';
          this.$emit('failed', this.rangeStatus);
        } else {
          this.rangeStatus = true;
          this.$emit('success', this.rangeStatus);
        }
      }
    },
  },
};
</script>
<style scoped>
.silder-range {
  background-color: #ffffff;
  position: relative;
  transition: 1s all;
  user-select: none;
  color: #10b981;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
}
#ssss {
  position: absolute;
  left: 4px;
  display: inline-block;
  width: 0;
  height: 42px;
  background-color: #10b981;
  border-radius: 4px 0 0 4px;
}
.silder-box {
  position: absolute;
  left: 4px;
  display: inline-block;
  width: 42px;
  height: 42px;
  color: #fff;
  background-color: #10b981;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
/* .silder-range.success {
  background-color: #7ac23c;
  color: #fff;
}
.silder-range.success i {
  color: #7ac23c;
} */
</style>
